module.exports = __webpack_public_path__ + "static/media/maplayer_1_1_centrum-01.64db01a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/01/assets/maplayer_1_1_centrum-01.svg
// module id = 341
// module chunks = 0